import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { AuthService } from 'app/core/auth/auth.service';
// import { DatePipe } from '@angular/common';
import ls from 'localstorage-slim';
import { ApiService } from 'app/providers/api.service';
import { FuseNavigationService } from '@fuse/components/navigation';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    // encapsulation  : ViewEncapsulation.None,
    // changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'user',
    // providers: [DatePipe]
})
export class UserComponent implements OnInit, OnDestroy {
    lstLgnusr: any;
    lgntme;
    lgnusr;
    attachments = [];

    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: any = {};

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    prfledtls: any;
    url_txt: any;


    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _authService: AuthService,
        public apiServ: ApiService,
        private fuseNavigationService: FuseNavigationService,
        // private datePipe: DatePipe
    ) {
    }




    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to user changes
        // console.log('ngOnInit')
        // this._userService.user$
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe((user: any) => {
        //         console.log(user)
        //         this.user = user;
        //         // Mark for check
        //         this._changeDetectorRef.markForCheck();
        //     });
        this.apiServ.setupdtprfle().subscribe((data) => {
            console.log(data)
            if (data && data.callfunc) {
                this.getprfledtls();
            }
        })

        let localJson = JSON.parse(ls.get('hms_loggedin_user'));
        console.log(localJson)
        this.user = localJson
        this.getprfledtls();
    }

    getprfledtls() {
        let rte = `admin/gtprfledtls`
        this.apiServ.get(rte).subscribe((res) => {
            this.prfledtls = []
            this.attachments = []
            console.log(res);
            if (res['status'] == 200) {
                this.prfledtls = res['data']
                if (this.prfledtls[0].usr_imge_url_tx) {
                    this.url_txt = this.prfledtls[0].usr_imge_url_tx
                    this.attachments.push({ base64: this.url_txt });
                }
                console.log(this.attachments);

            }

        });
    }
    ionViewWillEnter() {
        console.log('ionViewWillEnter')
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void {
        // Return if user is not available
        if (!this.user) {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void {
        // Navigate to the sign-in page immediately
        console.log("_________________________________ signout");
        this.apiServ.lgnUsrDtls = null
        this._authService._authenticated = false;
        ls.remove('accessToken')
        this.cleanupSession();
        this._router.navigate(['sign-in/home']);
        this.fuseNavigationService.onLogOutSetCustomTagsMenuItems();
    }

    private cleanupSession(): void {
        localStorage.clear();
        indexedDB.deleteDatabase('patient');
        indexedDB.deleteDatabase('services');
    }

    /**
     * Sign out
     */
    openProfile(): void {
        console.log("Click Profile")
        this._router.navigate(['/profile']);
    }

}
